import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigService } from "../../services/config.service";
import { Transaction } from "./transaction";

@Injectable({
  providedIn: "root"
})
export class TransactionErrorService {
  private httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      API_KEY: "ams-transaction-api-security-key"
    })
  };

  constructor(private http: HttpClient, private configService: ConfigService) { }

  get(factories: string, includePendingTransactions: boolean): Observable<Transaction[]> {
    return this.http.get<Transaction[]>(`${this.configService.config.transactionUrl}/api/transactionerror/getbyfactories?factories=${factories}&includePendingTransactions=${includePendingTransactions}`, this.httpOptions);
  }

  open(id: number, isPending: boolean, openOverride = false): Observable<any> {
    return this.http.put<any>(`${this.configService.config.transactionUrl}/api/transactionerror/opentransaction?id=${id}&isPending=${isPending}&openOverride=${openOverride}`, {}, this.httpOptions);
  }

  close(id: number, isPending: boolean, closeOverride = false): Observable<any> {
    return this.http.put<any>(`${this.configService.config.transactionUrl}/api/transactionerror/closetransaction?id=${id}&isPending=${isPending}&closeOverride=${closeOverride}`, {}, this.httpOptions);
  }

  openMultiple(ids: number[], openPending: boolean, openOverride = false): Observable<any> {
    return this.http.post<any>(`${this.configService.config.transactionUrl}/api/transactionerror/openMultipleTransactions`, JSON.stringify({ ids: ids, openPending: openPending, openOverride: openOverride }), this.httpOptions);
  }

  closeMultiple(ids: number[], closePending: boolean, closeOverride = false): Observable<any> {
    return this.http.post<any>(`${this.configService.config.transactionUrl}/api/transactionerror/closeMultipleTransactions`, JSON.stringify({ ids: ids, closePending: closePending, closeOverride: closeOverride }), this.httpOptions);
  }
}
